import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "4407815980006";
const PREFILLED_MESSAGE = "Hi Rebecca! I found you online and would love to chat about adventure travel 🌍";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILLED_MESSAGE)}`;

const WhatsAppButton = () => {
  return (
    <>
      {/* Mobile: full-width sticky bar */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex items-center justify-center gap-2 py-3.5 text-white font-display font-bold text-sm tracking-wide shadow-xl"
        style={{ backgroundColor: "#25D366" }}
        aria-label="Chat with Rebecca on WhatsApp"
      >
        <MessageCircle className="w-5 h-5" />
        Chat with Rebecca on WhatsApp
      </a>

      {/* Desktop: floating pill */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 hidden md:flex items-center gap-2 px-5 py-3 rounded-full text-white font-display font-bold text-sm tracking-wide shadow-xl transition-transform duration-300 hover:scale-105 animate-[slideUp_0.5s_ease-out_1s_both]"
        style={{ backgroundColor: "#25D366" }}
        aria-label="Ask Rebecca anything on WhatsApp"
      >
        <MessageCircle className="w-5 h-5" />
        Ask Rebecca anything
      </a>
    </>
  );
};

export default WhatsAppButton;
